import { useMutation } from 'arcway/lib/client'
import { useRef, useState } from 'react'
import { checkoutKey, checkoutErrorMessage } from '#lib/client/checkout.js'

export function useCheckout({ next, refresh, refreshSession } = {}) {
  const checkout = useMutation('/account/billing/checkout', { method: 'POST' })
  const keys = useRef(new Map())
  const busy = useRef(false)
  const [loadingPriceId, setLoadingPriceId] = useState(null)
  const [error, setError] = useState(null)
  async function startCheckout(priceId) {
    if (busy.current) return
    busy.current = true
    setLoadingPriceId(priceId)
    setError(null)
    try {
      const response = await checkout.trigger({
        priceId,
        idempotencyKey: checkoutKey(keys.current, priceId),
        ...(next ? { next } : {}),
      })
      if (
        !response.checkoutUrl ||
        new Date(response.expiresAt).getTime() <= Date.now()
      )
        throw new Error('Checkout has expired')
      window.location.assign(response.checkoutUrl)
    } catch (caught) {
      if (caught?.status === 401) {
        await refreshSession?.().catch(() => {})
        const path = `/api/billing/checkout?priceId=${encodeURIComponent(priceId)}${next ? `&next=${encodeURIComponent(next)}` : ''}`
        window.location.assign(`/signup?next=${encodeURIComponent(path)}`)
        return
      }
      await refresh?.().catch(() => {})
      if ([400, 404, 409].includes(caught?.status)) keys.current.delete(priceId)
      const message = checkoutErrorMessage(caught)
      setError(message)
      busy.current = false
      setLoadingPriceId(null)
      throw Object.assign(new Error(message), { status: caught?.status })
    }
  }
  return {
    startCheckout,
    loadingPriceId,
    error,
  }
}
